import { isUndefined } from 'lodash'
import React from 'react'

const ClientNameWithStatus = ({ data, children }) => {
  const statusColor = () => {
    switch (data.original.customer_status) {
    case 'historic': return 'red'
    case 'pending offboarding': return 'darkorange'
    default: 'none'
    }
  }

  const textStyle = { color: statusColor() }

  const statusText = () => {
    if (isUndefined(data.original.href)) {
      return <span style={textStyle}>{data.value}</span>
    } else {
      return <a href={data.original.href} style={textStyle}>{data.value}</a>
    }
  }

  return (
    <React.Fragment>
      {statusText()}
      {children}
    </React.Fragment>
  )
}
export default ClientNameWithStatus
